// import * as _ from 'lodash';

const TEMPLATE_NAME = 'VISITS_PEP';

const initialState = () => ({
  loading: false,
  loadedData: []
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      const newData = action.payload;
      return {
        ...state,
        loading: false,
        loadedData: newData
      };
    }
    case `${TEMPLATE_NAME}_CREATE`: {
      const newRow = action.payload;
      const loadedData = [...state.loadedData, newRow];
      return {
        ...state,
        loading: false,
        loadedData
      };
    }
    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
